<template>
  <div>
    <div class="nav-tree">
      <el-button @click="openModalAdd()" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} Tax Account</el-button>
    </div>
    <el-table
        max-height="600"
        :data="tableData"
        :empty-text="$t('general_noData')"
        style="width: 100%">
      <el-table-column
          label="ID"
          type="index"
          width="50">
      </el-table-column>
      <el-table-column
          prop="name"
          :label="$t('settings_accountThink_taxTypes_taxAccountName')">
      </el-table-column>
      <el-table-column
          :label="$t('settings_accountThink_taxTypes_accountGroup')">
        <template slot-scope="scope">
          {{scope.row.group.name}}
        </template>
      </el-table-column>
      <el-table-column
          width="200"
          :label="$t('settings_accountThink_taxTypes_currentBalance')">
        <template slot-scope="scope">
          {{formatPrice(scope.row.currentBalance)}}
        </template>
      </el-table-column>
      <el-table-column
          width="200"
          :label="$t('settings_accountThink_taxTypes_openingBalance')">
        <template slot-scope="scope">
          {{formatPrice(scope.row.openingBalance)}}
        </template>
      </el-table-column>
      <el-table-column
          width="100"
          :label="$t('settings_accountThink_taxTypes_currency')">
        <template slot-scope="scope">
          {{scope.row.currencyName}}
        </template>
      </el-table-column>
      <el-table-column
          :label="$t('settings_accountThink_taxTypes_createDate')"
          width="150">
        <template slot-scope="scope">
          {{moment(scope.row.createdDate).format('D MMM YY') }}
        </template>
      </el-table-column>
      <el-table-column
          width="120"
          :label="$t('settings_accountThink_taxTypes_operations')">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"></el-button>
          <el-button
              size="mini"
              type="danger"
              plain
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <create-setting-tax-account-modal
      ref="createSettingTaxAccountModal"
      @loadList="loadList"/>
  </div>
</template>

<script>
import axios from "axios";
import CreateSettingTaxAccountModal from "./settingAccountTaxes/CreateSettingTaxAccountModal";
let moment = require('moment')

export default {
  name: "SettingAccountTaxes",
  components: {CreateSettingTaxAccountModal},
  data() {
    return {
      moment: moment,
      tableData: []
    }
  },
  methods: {
    async loadList() {
      let loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.get(`/api/v1/account/accountOnlyTax?companyId=${this.$route.query.companyId}`)
        this.tableData = response.data.list
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    handleEdit(index, row) {
      console.log(index, row)
    },
    handleDelete(index, row) {
      console.log(index, row)
    },
    openModalAdd() {
      this.$refs.createSettingTaxAccountModal.openModal()
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style scoped>

</style>
